"use client";
import {
  DisclosureContextProvider,
  DisclosureScopedContextProvider
} from "./SJ5YBTFK.js";
import {
  createStoreContext
} from "./YIF72NQG.js";

// src/dialog/dialog-context.tsx
import { createContext } from "react";
var ctx = createStoreContext(
  [DisclosureContextProvider],
  [DisclosureScopedContextProvider]
);
var useDialogContext = ctx.useContext;
var useDialogScopedContext = ctx.useScopedContext;
var useDialogProviderContext = ctx.useProviderContext;
var DialogContextProvider = ctx.ContextProvider;
var DialogScopedContextProvider = ctx.ScopedContextProvider;
var DialogHeadingContext = createContext(void 0);
var DialogDescriptionContext = createContext(void 0);

export {
  useDialogContext,
  useDialogScopedContext,
  useDialogProviderContext,
  DialogContextProvider,
  DialogScopedContextProvider,
  DialogHeadingContext,
  DialogDescriptionContext
};
